import { Ban, CircleCheckBig, Info, X } from "lucide-react";
import style from "../../alert.module.css";
import { useContext } from "react";
import { AlertBlock, AlertType } from "../../AlertManager";
import { AppContext } from "../../../../../contexts/AppContext";

function getColorTheme(type: AlertType){
  if(type === "notification") return style.notificationTheme;
  else if(type === "error") return style.warningTheme;
  return style.successTheme;
}
function getColorIcon(type: AlertType){
  if(type === "notification") return <Ban className={style.icon}/>;
  else if(type === "error") return <Info className={style.icon}/>;
  return <CircleCheckBig className={style.icon}/>
}

function Alert({ data, id }: Readonly<AlertBlock>) {
  const { removeAlert } = useContext(AppContext);
  const colorTheme = getColorTheme(data.type);

  return (
    <section className={colorTheme}>
      <div className={style.alert}>
        <div className={style.topRow}>
          {getColorIcon(data.type)}
          {data.title}
          {data.closeButton && <X onClick={() => removeAlert(id)} className={style.close} strokeWidth="2" />}
        </div>
        <div className={style.bottomRow}>{data.text}</div>
      </div>
    </section>
  );
}
export default Alert;
